import { render, staticRenderFns } from "./Sync.vue?vue&type=template&id=7c64456e"
import script from "./Sync.vue?vue&type=script&lang=ts"
export * from "./Sync.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports